import styled, { keyframes } from 'styled-components'
import { darkBlue, darkSlateBlue, darkGrey, linkNavyBlue } from '../../../styles/settings/colors'
import {
  title18Galano,
  title24Galano,
  txt14OpenSans,
  title32GalanoBold
} from '../../../styles/settings/types'

import content from '../../../styles/_objects/content'
import rem from '../../../styles/tools/rem'
import media from '../../../styles/tools/media'

export const Content = styled.div`
  ${content};
  margin: ${rem('42px')} auto;
  ${media.small`
      margin: ${rem('29px')} auto;
  `};
`

export const Paragraph = styled.p`
  ${txt14OpenSans} color: ${darkBlue};
  width: ${rem('270px')};
  margin-top: ${rem('7px')};
  ${media.large`
    width: ${rem('313px')};
    margin: 0;
  `};
`

export const Heading = styled.h1`
  ${title24Galano}
  color: ${darkSlateBlue};
  font-size: 48px;
  font-weight: bold;
  line-height: 1.08;
  letter-spacing: normal;
  margin: 0 0 ${rem('10px')};
  ${media.small`
    ${title18Galano}
    margin: ${rem('8px')} 0;
  `};
`

export const WrapperButtons = styled.div`
  display: flex;
  justify-content: space-between;
  min-width: 400px;
  & > div {
    margin: 0 15px;
  }
`

export const BoxHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
`

export const SearchBox = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: ${rem('20px')};
  flex: 1;
  flex-direction: column;
  align-items: flex-end;
`

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

export const LoadingContainer = styled.div`
  margin-top: ${rem('20px')};
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    animation: ${spin} 1s linear infinite;
  }
`

export const LoadingText = styled.span`
  margin-left: ${rem('10px')};
  ${txt14OpenSans};
  color: ${darkGrey};
`

export const SubHeader = styled.div`
  display: flex;
  flex-direction: row;
`

export const iconColor = `fill: ${linkNavyBlue}`

export const HeadingContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

export const CardAndIconWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  margin-bottom: 20px;
`

export const IdentifiersCardWrapper = styled.div`
  width: 264px;
  height: 96px;
  display: flex;
  border: 2px solid #e2e1eb;
  border-radius: 8px;
  margin-right: 20px;
  padding: 16px;
  justify-content: space-between;
  span {
    ${title32GalanoBold};
    font-size: 32px;
    color: ${darkSlateBlue};
    line-height: 31px;
    margin-bottom: 8px;
  }
  p {
    ${txt14OpenSans};
    color: ${darkSlateBlue};
    margin: 0;
  }
  img {
  }
`

export const IdentifiersCardLabel = styled.div`
  display: flex;
  flex-direction: column;
`

export const ButtonIcon = styled.a`
  display: inline-block;
  width: ${rem('31px')};
  height: ${rem('31px')};
  cursor: pointer;

  img {
    width: 100%;
    height: auto;
  }
`



// WEBPACK FOOTER //
// ./src/app/pages/DashboardIdentifiers/styles.js